import axios from 'axios';

export default (configurations) => {
  const url = '/api/estimates/configurations';
  const payload = {
    configurations,
  };

  return axios.post(url, payload);
};
